import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const CloseBold = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" fill="none">
    <path d="M6.9375 5.8775C7.2275 6.1675 7.2275 6.6475 6.9375 6.9375C6.7875 7.0875 6.5975 7.1575 6.4075 7.1575C6.2175 7.1575 6.0275 7.0875 5.8775 6.9375L3.5775 4.6375L1.2775 6.9375C1.1275 7.0875 0.9375 7.1575 0.7475 7.1575C0.5575 7.1575 0.3675 7.0875 0.2175 6.9375C-0.0725 6.6475 -0.0725 6.1675 0.2175 5.8775L2.5175 3.5775L0.2175 1.2775C-0.0725 0.987499 -0.0725 0.5075 0.2175 0.2175C0.5075 -0.0725 0.987499 -0.0725 1.2775 0.2175L3.5775 2.5175L5.8775 0.2175C6.1675 -0.0725 6.6475 -0.0725 6.9375 0.2175C7.2275 0.5075 7.2275 0.987499 6.9375 1.2775L4.6375 3.5775L6.9375 5.8775Z" />
  </svg>
)

export default withDefaultStyles(CloseBold)
